export default {
  "content": "<g fill=\"#3F4450\" clip-path=\"url(#a)\"><path d=\"M16.5 13.75h-9a.752.752 0 01-.75-.75c0-.412.338-.75.75-.75h9c.413 0 .75.338.75.75s-.337.75-.75.75z\"/><path d=\"M11.25 18.25a.743.743 0 01-.578-.27l-3.75-4.5a.748.748 0 010-.96l3.75-4.5a.756.756 0 011.058-.097c.315.263.36.735.098 1.058L8.475 13l3.353 4.02a.75.75 0 01-.578 1.23z\"/></g><rect width=\"22\" height=\"22\" x=\"1\" y=\"2\" stroke=\"#3F4450\" stroke-width=\"2\" rx=\"11\"/><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M6 7h12v12H6z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "30",
    "fill": "none"
  }
};